module.exports = __webpack_public_path__ + "img/8974c7b7b37241f190625804a84d979a.cbedff2d.png";